<template>
  <div>
    <GestorCentralizadoFiltersPanel
      :filters.sync="filters"
      :loading="loading || saving"
      @clear="resetFilters"
      @search="handleSearch"
      @proveedor-label-change="proveedorLabel = $event"
      @periodo-label-change="periodoLabel = $event"
    />

    <GestorCentralizadoResumen
      :resumen="resumen"
      :loading="loading && !hasFetched"
    />

    <GestorCentralizadoTable
      :items="items"
      :loading="loading"
      :load-error="loadError"
      :empty-text="emptyTableText"
      :editable="editable"
      :estado-liquidacion="estadoLiquidacion"
      :id-liquidacion-cab="idLiquidacionCab"
      :current-page.sync="currentPage"
      :per-page="perPage"
      :total-rows="totalRows"
      @start-observar="handleStartObservar"
      @cost-change="handleCostChange"
      @mark-observada="handleMarkObservada"
      @confirm-row="handleConfirmRow"
      @revert-row="handleRevertRow"
      @open-penalidad="handleOpenPenalidad"
      @open-adicional="handleOpenAdicional"
      @delete-adicional="handleDeleteAdicional"
      @detalle-change="handleDetalleChange"
      @detalle-costo-change="handleDetalleCostoChange"
      @integer-only="handleIntegerOnly"
      @cantidad-change="handleCantidadChange"
      @cantidad-blur="handleCantidadBlur"
    />

    <GestorCentralizadoActionsBar
      :visible="showActionsBar"
      :disabled="loading || saving"
      :can-save="canSave"
      :can-observe="canObserve"
      :can-generate="canGenerate"
      @save="handleSave"
      @observe="handleObserve"
      :can-add-manual="!!idLiquidacionCab"
      @add-manual="$bvModal.show('modal-agregar-os-manual')"
      @generate="$bvModal.show('modal-confirmar-generar-liquidacion')"
    />
    <GestorCentralizadoAgregarManualModal
      :busy="saving"
      :proveedor-label="proveedorLabel"
      :periodo-label="periodoLabel"
      @guardar="handleAgregarOsManual"
    />
    <GestorCentralizadoModalAgregarAdicional
      v-model="showAdicionalModal"
      :target-os="adicionalTargetOs"
      @agregar="handleConfirmarAgregarAdicional"
    />
    <GestorCentralizadoPenalidadModal
      v-model="showPenalidadModal"
      :penalidad-draft="penalidadDraft"
      :catalog="penalidadesCatalogo"
      :total-con-igv="penalidadTarget ? penalidadTarget.totalConIgv : 0"
      @hidden="handlePenalidadHidden"
      @tipo-change="handlePenalidadTipoChange"
      @recalculate="handlePenalidadRecalculate"
      @delete-penalidad="handleDeletePenalidad"
      @save-penalidad="handleSavePenalidad"
    />
    <b-modal
      id="modal-confirmar-generar-liquidacion"
      title="Confirmar Generación de Liquidación"
      centered
      body-class="text-center p-4"
    >
      <font-awesome-icon
        icon="exclamation-circle"
        class="text-warning mb-3"
        style="font-size: 3rem;"
      />
      <p class="mb-3" style="font-size: 1.1rem; color: #1e293b;">
        Al seleccionar "Aceptar" se generará la liquidación<br />
        y no podrán efectuarse cambios.
      </p>

      <p class="font-weight-bold mb-2" style="font-size: 1.15rem; color: #000;">
        ¿Deseas continuar?
      </p>

      <template #modal-footer>
        <div class="w-100 d-flex justify-content-center align-items-center">
          <b-button
            class="bg-grey-btn mx-2"
            @click="$bvModal.hide('modal-confirmar-generar-liquidacion')"
          >
            Regresar
          </b-button>
          <b-button class="btn-orange mx-2" @click="confirmarYGenerar">
            Aceptar
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";

import GestorCentralizadoActionsBar from "./GestorCentralizadoActionsBar.vue";
import GestorCentralizadoFiltersPanel from "./GestorCentralizadoFiltersPanel.vue";
import GestorCentralizadoPenalidadModal from "./GestorCentralizadoPenalidadModal.vue";
import GestorCentralizadoResumen from "./GestorCentralizadoResumen.vue";
import GestorCentralizadoTable from "./GestorCentralizadoTable.vue";
import GestorCentralizadoAgregarManualModal from "./GestorCentralizadoAgregarManualModal.vue";
import GestorCentralizadoModalAgregarAdicional from "./GestorCentralizadoModalAgregarAdicional.vue";
import { agregarOsManualGestor } from "@/services/gestor-centralizado/gestor-centralizado.api";
import { recalculateRowCosts } from "@/services/gestor-centralizado/gestor-centralizado.calculations";
import {
  //confirmarObservacionGestor,
  fetchGestorCentralizado,
  fetchPenalidadesCatalogo,
  generarLiquidacionGestor,
  getGestorCentralizadoErrorMessage,
  observarPreLiquidacionGestor,
  saveGestorCentralizado,
} from "@/services/gestor-centralizado/gestor-centralizado.api";
import {
  GESTOR_CENTRALIZADO_DEFAULT_PER_PAGE,
  GESTOR_ESTADO_ACEPTADA,
  GESTOR_ESTADO_OBSERVADA,
  MESSAGES,
} from "@/services/gestor-centralizado/gestor-centralizado.constants";
import {
  canConfirmObservacionGestor,
  getDefaultGestorCentralizadoFilters,
} from "@/services/gestor-centralizado/gestor-centralizado.contract";
import { getEmptyGestorCentralizadoResumen } from "@/services/gestor-centralizado/gestor-centralizado.mapper";
import {
  canGenerateGestorCentralizado,
  canObserveGestorCentralizado,
  canSaveGestorCentralizado,
  showActionsBar as shouldShowActionsBar,
} from "@/services/gestor-centralizado/gestor-centralizado.rules";

export default {
  name: "GestorCentralizadoTab",

  components: {
    GestorCentralizadoActionsBar,
    GestorCentralizadoFiltersPanel,
    GestorCentralizadoPenalidadModal,
    GestorCentralizadoResumen,
    GestorCentralizadoTable,
    GestorCentralizadoAgregarManualModal,
    GestorCentralizadoModalAgregarAdicional,
  },

  data() {
    return {
      revertingPage: false,
      filters: getDefaultGestorCentralizadoFilters(),
      resumen: getEmptyGestorCentralizadoResumen(),
      items: [],
      totalRows: 0,
      idLiquidacionCab: null,
      estadoLiquidacion: "",
      loading: false,
      saving: false,
      loadError: "",
      hasFetched: false,
      currentPage: 1,
      perPage: GESTOR_CENTRALIZADO_DEFAULT_PER_PAGE,
      filterDebounceTimer: null,
      penalidadesCatalogo: [],
      penalidadTarget: null,
      penalidadDraft: null,
      showPenalidadModal: false,
      showAdicionalModal: false,
      adicionalTargetOs: null,
      editable: true,
      proveedorLabel: "",
      periodoLabel: "",
    };
  },

  computed: {
    ...mapState("module", ["username"]),

    emptyTableText() {
      if (!this.filters.idProv) return MESSAGES.SELECT_PROVEEDOR_HINT;
      if (this.hasFetched) return MESSAGES.EMPTY_TABLE_FILTERED;
      return MESSAGES.EMPTY_TABLE;
    },

    showActionsBar() {
      return shouldShowActionsBar(this.estadoLiquidacion);
    },

    canSave() {
      return (
        this.items.length > 0 &&
        canSaveGestorCentralizado(this.estadoLiquidacion)
      );
    },

    canObserve() {
      return canObserveGestorCentralizado(
        this.estadoLiquidacion,
        this.items,
        this.resumen,
      );
    },

    canGenerate() {
      return (
        this.items.length > 0 &&
        canGenerateGestorCentralizado(
          this.estadoLiquidacion,
          this.items,
          this.resumen,
        )
      );
    },
  },

  watch: {
    currentPage(newPage, oldPage) {
      if (this.revertingPage) {
        this.revertingPage = false;
        return;
      }

      if (this.hasUnsavedChanges()) {
        this.$bvModal
          .msgBoxConfirm(
            "Tienes cambios sin guardar. Si cambias de página, se perderán. ¿Deseas continuar sin guardar?",
            {
              title: "Cambios sin guardar",
              size: "sm",
              buttonSize: "sm",
              okVariant: "danger",
              okTitle: "Continuar sin guardar",
              cancelTitle: "Cancelar",
              centered: true,
            },
          )
          .then((confirmed) => {
            if (confirmed) {
              this.loadData();
            } else {
              this.revertingPage = true;
              this.currentPage = oldPage;
            }
          });
      } else {
        this.loadData();
      }
    },
  },

  created() {
    this.loadPenalidadesCatalogo();
    //this.loadData();
  },

  beforeDestroy() {
    clearTimeout(this.filterDebounceTimer);
  },

  methods: {
    handleCantidadChange(row) {
      row._dirty = true;
    },
    hasUnsavedChanges() {
      return this.items.some((item) => item._dirty === true);
    },
    handleStartObservar(row) {
      this.$set(row, "_observando", true);
      this.$set(row, "_obsTmp", row.obsGestor || "");
    },
    async loadPenalidadesCatalogo() {
      try {
        this.penalidadesCatalogo = await fetchPenalidadesCatalogo();
      } catch (error) {
        this.$bvToast.toast(
          getGestorCentralizadoErrorMessage(error) ||
            MESSAGES.PENALIDAD_CATALOG_ERROR,
          { variant: "danger", solid: true },
        );
      }
    },
    handleSearch() {
      clearTimeout(this.filterDebounceTimer);
      if (this.currentPage !== 1) {
        this.currentPage = 1;
      } else {
        this.loadData();
      }
    },
    async loadData() {
      if (!this.filters.idProv) {
        this.loading = false;
        this.loadError = "";
        this.hasFetched = false;
        this.items = [];
        this.totalRows = 0;
        this.idLiquidacionCab = null;
        this.estadoLiquidacion = "";
        this.resumen = getEmptyGestorCentralizadoResumen();
        return;
      }
      this.loading = true;
      this.loadError = "";

      try {
        const data = await fetchGestorCentralizado(this.filters, {
          page: this.currentPage,
          pageSize: this.perPage,
        });

        this.hasFetched = true;
        this.resumen = data.resumen;

        this.items = data.items.flatMap((item) => {
          const { detalles, ...padre } = item;
          const filaPadre = {
            ...padre,
            id: padre.idLiquidacionOs,
            esAdicional: false,
          };

          const filasAdicionales = (detalles || []).map((d) => {
            const cantidadOriginal = Number(d.cantidad) || 1;
            const costoUnitarioSinIgv =
              Number(d.costoTotalSinIgv) / cantidadOriginal;
            const costoUnitarioConIgv =
              Number(d.costoTotalConIgv) / cantidadOriginal;

            return {
              ...d,
              id: d.idDetalle ? `det_${d.idDetalle}` : `adic_${item.idLiquidacionOs}_${d.orden}`,
              cantidad: d.cantidad,
              idLiquidacionOs: item.idLiquidacionOs,
              codTienda: item.codTienda,
              nombreTienda: item.nombreTienda,
              tipoCliente: item.tipoCliente,
              cliente: item.cliente,
              usuarioProveedor: item.usuarioProveedor,
              nroOs: `Adicional ${d.orden || ""}`,
              estado: item.estado,
              esAdicional: true,
              _parentDetSequenceId: item.detSequenceId,
              _dirty: d._dirty || false,
              _costoUnitarioSinIgv: costoUnitarioSinIgv,
              _costoUnitarioConIgv: costoUnitarioConIgv,
            };
          });

          filaPadre._detallesOriginales = filasAdicionales.map((f) => ({ ...f }));

          return [filaPadre, ...filasAdicionales];
        });

        this.totalRows = data.total;
        this.idLiquidacionCab = data.idLiquidacionCab;
        this.estadoLiquidacion = data.estadoLiquidacion;
      } catch (error) {
        this.hasFetched = false;
        this.items = [];
        this.totalRows = 0;
        this.idLiquidacionCab = null;
        this.estadoLiquidacion = "";
        this.loadError = getGestorCentralizadoErrorMessage(error);
      } finally {
        this.loading = false;
      }
    },

    resetFilters() {
      this.filters = getDefaultGestorCentralizadoFilters();
    },

    markRowDirty(row) {
      this.$set(row, "_dirty", true);
    },

    applyRowCosts(row) {
      Object.assign(row, recalculateRowCosts(row));
      this.markRowDirty(row);
    },

    handleCostChange(row) {
      this.applyRowCosts(row);
    },

    handleMarkObservada(row) {
      row.estado = GESTOR_ESTADO_OBSERVADA;
      this.markRowDirty(row);
    },

    async handleConfirmRow(row) {
      if (!canConfirmObservacionGestor(row)) {
        this.$bvToast.toast(MESSAGES.CONFIRM_OBS_REQUIRED, {
          variant: "warning",
          solid: true,
          autoHideDelay: 1500,
        });
        return;
      }
      row.estado = GESTOR_ESTADO_ACEPTADA;
      row.confirmadaGestor = true;
      row._obsTmp = null;
      this.markRowDirty(row);
      this.$bvToast.toast(MESSAGES.CONFIRM_OBS_SUCCESS, {
        variant: "success",
        solid: true,
      });
      /*this.saving = true;
      try {
        await confirmarObservacionGestor(row, this.username);
        row.estado = GESTOR_ESTADO_ACEPTADA;
        row.confirmadaGestor = true;
        row._obsTmp = null;
        row._dirty = false;
        this.$bvToast.toast(MESSAGES.CONFIRM_OBS_SUCCESS, {
          variant: "success",
          solid: true,
        });
        await this.loadData();
      } catch (error) {
        this.$bvToast.toast(
          getGestorCentralizadoErrorMessage(error) || MESSAGES.CONFIRM_OBS_ERROR,
          { variant: "danger", solid: true },
        );
      } finally {
        this.saving = false;
      } */
    },
    handleCantidadBlur(row) {
      if (
        row.cantidad === "" ||
        row.cantidad === null ||
        row.cantidad === undefined
      ) {
        row.cantidad = Number(row._cantidadOriginal ?? 1);
        return;
      }
      const n = Number(row.cantidad);
      if (!Number.isFinite(n) || (row.esAdicional ? n <= 0 : n < 0)) {
        row.cantidad = Number(row._cantidadOriginal ?? 1);
      }
      
    },
    handleRevertRow(row) {
      const cantidadOriginal = Number(row._cantidadOriginal ?? row.cantidad ?? 1);
      row.cantidad = cantidadOriginal;

      Object.assign(
        row,
        recalculateRowCosts({
          ...row,
          costoSinIgv: row._costoOriginal,
          cantidad: cantidadOriginal,
        }),
      );
      row.estado = row._estadoOriginal;
      row._obsTmp = row._obsBackofficeOriginal || null;
      row.obsGestor = row._obsBackofficeOriginal || "";
      row.obsBackoffice = row._obsBackofficeOriginal || "";
      row.confirmadaGestor = false;
      this.$set(row, "_observando", false);
      row._dirty = false;
      row._adicionalesEliminar = [];


      const seq = row.detSequenceId;
      this.items = this.items.filter(
        (it) => !(it.esAdicional && it._parentDetSequenceId === seq && it._nuevo)
      );

      if (Array.isArray(row._detallesOriginales) && row._detallesOriginales.length > 0) {
        const parentIndex = this.items.findIndex(
          (it) => !it.esAdicional && it.detSequenceId === seq
        );
        if (parentIndex !== -1) {
          row._detallesOriginales.forEach((orig, idx) => {
            const existingItem = this.items.find(
              (it) => it.esAdicional && it._parentDetSequenceId === seq && it.idDetalle === orig.idDetalle
            );
            if (existingItem) {
              Object.assign(existingItem, { ...orig, _dirty: false });
            } else {
              this.items.splice(parentIndex + 1 + idx, 0, { ...orig, _dirty: false });
            }
          });
        }
      }

      this.$bvToast.toast(MESSAGES.REVERT_SUCCESS, {
        variant: "info",
        solid: true,
      });
    },

        
    handleOpenAdicional(row) {
      if (this.estadoLiquidacion !== "PRE_LIQUIDACION") {
        this.$bvToast.toast("Solo se pueden agregar adicionales en estado PRE_LIQUIDACION", {
          variant: "warning",
          solid: true,
        });
        return;
      }
      if (row.estado === "OBSERVADA" || row._observando) {
        this.$bvToast.toast("No se pueden agregar adicionales a una OS observada", {
          variant: "warning",
          solid: true,
        });
        return;
      }
      this.adicionalTargetOs = row;
      this.showAdicionalModal = true;
    },

    handleConfirmarAgregarAdicional(formData) {
      const parent = this.adicionalTargetOs;
      if (!parent) return;

      const parentSeq = parent.detSequenceId;
      const hermanos = this.items.filter(
        (item) => item.esAdicional && item._parentDetSequenceId === parentSeq
      );

      const letrasUsadas = new Set(
        hermanos.map((h) => {
          if (h.orden) return String(h.orden).trim().toUpperCase();
          const match = String(h.nroOs).match(/Adicional\s+([A-Z])/i);
          return match ? match[1].toUpperCase() : "";
        }).filter(Boolean)
      );

      let nextCharCode = 65; // 'A'
      while (letrasUsadas.has(String.fromCharCode(nextCharCode))) {
        nextCharCode++;
      }
      const siguienteLetra = String.fromCharCode(nextCharCode);

      const cantidad = Number(formData.cantidad) || 1;
      const costoUnitarioSinIgv = Number(formData.costoSinIgv) || 0;
      const costoUnitarioConIgv = Number(formData.costoConIgv) || 0;
      const costoTotalSinIgv = Number((costoUnitarioSinIgv * cantidad).toFixed(2));
      const costoTotalConIgv = Number((costoUnitarioConIgv * cantidad).toFixed(2));
      const igv = Number((costoTotalConIgv - costoTotalSinIgv).toFixed(2));

      const nuevoAdicional = {
        id: `nuevo_${parent.detSequenceId}_${siguienteLetra}_${Date.now()}`,
        idDetalle: 0,
        idLiquidacionOs: parent.idLiquidacionOs,
        codTienda: parent.codTienda ?? parent.codigoTienda,
        nombreTienda: parent.nombreTienda,
        tipoCliente: parent.tipoCliente,
        cliente: parent.cliente,
        usuarioProveedor: parent.usuarioProveedor,
        orden: siguienteLetra,
        nroOs: `Adicional ${siguienteLetra}`,
        skuServicio: formData.skuServicio,
        servicio: formData.descripcionServicio || formData.skuServicio,
        skuProducto: formData.skuProducto,
        producto: formData.descripcionProducto || formData.skuProducto,
        cantidad: cantidad,
        costoSinIgv: costoUnitarioSinIgv,
        costoConIgv: costoUnitarioConIgv,
        costoTotalSinIgv: costoTotalSinIgv,
        costoTotalConIgv: costoTotalConIgv,
        totalFacturarSinIgv: costoTotalSinIgv,
        totalFacturarConIgv: costoTotalConIgv,
        igv: igv,
        penalidad: 0,
        obsProveedor: formData.obsProveedor
          ? `[AGREGADO POR GESTOR] ${formData.obsProveedor}`
          : "[AGREGADO POR GESTOR]",
        obsGestor: formData.obsProveedor || "",
        estado: parent.estado,
        esAdicional: true,
        _parentDetSequenceId: parent.detSequenceId,
        _costoUnitarioSinIgv: costoUnitarioSinIgv,
        _costoUnitarioConIgv: costoUnitarioConIgv,
        _nuevo: true,
        _dirty: true,
      };

      const parentIndex = this.items.findIndex(
        (item) => !item.esAdicional && item.detSequenceId === parent.detSequenceId
      );
      if (parentIndex !== -1) {
        let insertIndex = parentIndex + 1;
        for (let i = parentIndex + 1; i < this.items.length; i++) {
          if (this.items[i].esAdicional && this.items[i]._parentDetSequenceId === parentSeq) {
            insertIndex = i + 1;
          } else {
            break;
          }
        }
        this.items.splice(insertIndex, 0, nuevoAdicional);
      } else {
        this.items.push(nuevoAdicional);
      }

      this.markRowDirty(parent);

      this.$bvToast.toast("Adicional agregado a la lista. Recuerde guardar los cambios.", {
        variant: "success",
        solid: true,
      });
    },

    handleDeleteAdicional(detalle) {
      if (this.estadoLiquidacion !== "PRE_LIQUIDACION") {
        this.$bvToast.toast("Solo se pueden eliminar adicionales en estado PRE_LIQUIDACION", {
          variant: "warning",
          solid: true,
        });
        return;
      }

      this.$bvModal
        .msgBoxConfirm(`¿Está seguro de eliminar ${detalle.nroOs || "este adicional"}?`, {
          title: "Confirmar eliminación",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Eliminar",
          cancelTitle: "Cancelar",
          centered: true,
        })
        .then((confirmed) => {
          if (!confirmed) return;

          const parentSeq = detalle._parentDetSequenceId;
          const padre = this.items.find(
            (item) => !item.esAdicional && item.detSequenceId === parentSeq
          );

          if (detalle.idDetalle && detalle.idDetalle > 0) {
            if (padre) {
              if (!padre._adicionalesEliminar) {
                this.$set(padre, "_adicionalesEliminar", []);
              }
              padre._adicionalesEliminar.push(detalle.idDetalle);
            }
          }

          const idx = this.items.indexOf(detalle);
          if (idx !== -1) {
            this.items.splice(idx, 1);
          }

          if (padre) {
            this.markRowDirty(padre);
          }

          this.$bvToast.toast("Adicional eliminado de la lista. Recuerde guardar los cambios.", {
            variant: "info",
            solid: true,
          });
        });
    },

    handleDetalleChange(detalle) {
      if (!Number.isInteger(Number(detalle.cantidad))) {
        this.$bvToast.toast("La cantidad debe ser entera", {
          variant: "warning",
          solid: true,
        });
      }

      this.$set(detalle, "_dirty", true);

      const parent = this.items.find(
        (it) => !it.esAdicional && it.detSequenceId === detalle._parentDetSequenceId
      );
      if (parent) {
        this.markRowDirty(parent);
      }
    },

    handleDetalleCostoChange(detalle) {
      Object.assign(detalle, recalculateRowCosts(detalle));
      this.$set(detalle, "_dirty", true);
    },

    handleIntegerOnly(event) {
      if ([".", ",", "e", "-"].includes(event.key)) {
        event.preventDefault();
      }
    },
    confirmarYGenerar() {
      this.$bvModal.hide("modal-confirmar-generar-liquidacion");
      this.handleGenerate();
    },
    handleOpenPenalidad(row) {
      if (!row.penalidades) {
        this.$set(row, "penalidades", []);
      }

      this.penalidadTarget = row;
      const current = row.penalidades[0];

      this.penalidadDraft = current
        ? {
            idPenalidad: current.idPenalidad ?? current.id ?? null,
            tipoId: current.tipoId ?? null,
            codigo: current.codigo ?? null,
            descripcion: current.descripcion ?? "",
            monto: Number(current.monto ?? 0),
            porcentaje: current.porcentaje ?? null,
            precioMercaderia: Number(current.precioMercaderia ?? 0),
            flete: Number(current.flete ?? 0),
          }
        : {
            idPenalidad: null,
            tipoId: null,
            codigo: null,
            descripcion: "",
            monto: 0,
            porcentaje: null,
            precioMercaderia: 0,
            flete: 0,
          };

      this.showPenalidadModal = true;
    },

    handlePenalidadHidden() {
      this.penalidadTarget = null;
      this.penalidadDraft = null;
    },

    handlePenalidadTipoChange(draft) {
      const tipo = this.penalidadesCatalogo.find(
        (item) => item.id === draft.tipoId,
      );
      if (!tipo) return;

      draft.descripcion = tipo.descripcion;
      draft.porcentaje = tipo.porcentaje;

      if (tipo.reglaTipo === "PRECIO_MERCADERIA_DEVUELTA") {
        draft.precioMercaderia = 0;
        draft.flete = 0;
        draft.monto = 0;
        return;
      }

      const base = Number(this.penalidadTarget?.totalConIgv || 0);
      draft.monto = +((base * Number(tipo.porcentaje || 0)) / 100).toFixed(2);
    },

    handlePenalidadRecalculate(draft) {
      draft.monto = +(
        Number(draft.precioMercaderia || 0) + Number(draft.flete || 0)
      ).toFixed(2);
    },

    handleDeletePenalidad() {
      if (!this.penalidadTarget) return;

      this.$bvModal
        .msgBoxConfirm("¿Está seguro de eliminar esta penalidad?", {
          title: "Confirmar eliminación",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Eliminar",
          cancelTitle: "Cancelar",
          centered: true,
        })
        .then((confirmed) => {
          if (!confirmed) return;

          this.$set(this.penalidadTarget, "_eliminarPenalidad", true);
          this.$set(this.penalidadTarget, "penalidades", []);
          this.$set(this.penalidadTarget, "penalidad", 0);
          this.markRowDirty(this.penalidadTarget);

          this.showPenalidadModal = false;

          this.$bvToast.toast(
            "Penalidad eliminada. Recuerde guardar los cambios.",
            {
              variant: "info",
              solid: true,
            },
          );
        });
    },

    handleSavePenalidad() {
      const row = this.penalidadTarget;
      const draft = this.penalidadDraft;
      if (!row || !draft?.tipoId) {
        this.$bvToast.toast(MESSAGES.PENALIDAD_SELECT_TYPE, {
          variant: "warning",
          solid: true,
        });
        return;
      }

      const tipo = this.penalidadesCatalogo.find(
        (item) => item.id === draft.tipoId,
      );
      if (!tipo) {
        this.$bvToast.toast(MESSAGES.PENALIDAD_INVALID_TYPE, {
          variant: "warning",
          solid: true,
        });
        return;
      }

      row.penalidades = [
        {
          idPenalidad: draft.idPenalidad ?? null,
          tipoId: draft.tipoId,
          codigo: tipo.codigo,
          descripcion: tipo.descripcion,
          porcentaje: tipo.porcentaje ?? 0,
          monto: Number(draft.monto || 0),
          precioMercaderia: Number(draft.precioMercaderia || 0),
          flete: Number(draft.flete || 0),
        },
      ];
      row._eliminarPenalidad = false;
      this.markRowDirty(row);
      this.showPenalidadModal = false;
    },
    async handleAgregarOsManual({ idOsDet, adicionales, cantidad }) {
      if (!this.idLiquidacionCab || this.saving) return;

      this.saving = true;
      try {
        await agregarOsManualGestor(
          this.idLiquidacionCab,
          idOsDet,
          this.username,
          adicionales,
          cantidad,
        );
        this.$bvModal.hide("modal-agregar-os-manual");
        this.$bvToast.toast(MESSAGES.AGREGAR_MANUAL_SUCCESS, {
          variant: "success",
          solid: true,
        });
        await this.loadData();
      } catch (error) {
        this.$bvToast.toast(
          getGestorCentralizadoErrorMessage(error) ||
            MESSAGES.AGREGAR_MANUAL_ERROR,
          { variant: "danger", solid: true },
        );
      } finally {
        this.saving = false;
      }
    },
    async handleSave() {
      if (!this.idLiquidacionCab) return;

      this.saving = true;
      try {
        await saveGestorCentralizado(
          this.items,
          this.idLiquidacionCab,
          this.username,
        );
        this.$bvToast.toast(MESSAGES.SAVE_SUCCESS, {
          variant: "success",
          solid: true,
        });
        await this.loadData();
      } catch (error) {
        const message =
          error.code === "NO_CHANGES"
            ? MESSAGES.NO_CHANGES_TO_SAVE
            : getGestorCentralizadoErrorMessage(error) || MESSAGES.SAVE_ERROR;
        this.$bvToast.toast(message, {
          variant: error.code === "NO_CHANGES" ? "info" : "danger",
          solid: true,
        });
      } finally {
        this.saving = false;
      }
    },

    async handleObserve() {
      if (!this.idLiquidacionCab) return;

      this.saving = true;
      try {
        await observarPreLiquidacionGestor(
          this.idLiquidacionCab,
          this.username,
        );
        this.$bvToast.toast(MESSAGES.OBSERVE_SUCCESS, {
          variant: "success",
          solid: true,
        });
        await this.loadData();
      } catch (error) {
        this.$bvToast.toast(
          getGestorCentralizadoErrorMessage(error) || MESSAGES.OBSERVE_ERROR,
          { variant: "danger", solid: true },
        );
      } finally {
        this.saving = false;
      }
    },

    async handleGenerate() {
      if (!this.idLiquidacionCab) return;

      this.saving = true;
      try {
        await generarLiquidacionGestor(this.idLiquidacionCab, this.username);
        this.$bvToast.toast(MESSAGES.GENERATE_SUCCESS, {
          variant: "success",
          solid: true,
        });
        await this.loadData();
      } catch (error) {
        this.$bvToast.toast(
          getGestorCentralizadoErrorMessage(error) || MESSAGES.GENERATE_ERROR,
          { variant: "danger", solid: true },
        );
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
